export const unions = {
  '2': 2,
  '3': 3,
  '9': 9,
  '12': 12,
  '17': 17,
  '37': 37,
  '42': 42,
  '44': 44,
  '47': 47,
  '51': 51,
  '53': 53,
  '55': 55,
  '57': 57,
  '66': 66,
  '70': 70,
  '71': 71,
  '77': 77,
  '80': 80,
  '84': 84,
  '89': 89,
  '102': 102,
  '104': 104,
  '105': 105,
  '111': 111,
  '113': 113,
  '115': 115,
  '120': 120,
  '125': 125,
  '126': 126,
  '141': 141,
  '145': 145,
  '160': 160,
  '164': 164,
  '175': 175,
  '177': 177,
  '193': 193,
  '196': 196,
  '206': 206,
  '220': 220,
  '222': 222,
  '238': 238,
  '245': 245,
  '254': 254,
  '258': 258,
  '269': 269,
  '270': 270,
  '278': 278,
  '291': 291,
  '295': 295,
  '301': 301,
  '303': 303,
  '304': 304,
  '307': 307,
  '309': 309,
  '317': 317,
  '322': 322,
  '342': 342,
  '351': 351,
  '353': 353,
  '369': 369,
  '379': 379,
  '396': 396,
  '400': 400,
  '402': 402,
  '424': 424,
  '426': 426,
  '429': 429,
  '443': 443,
  '449': 449,
  '456': 456,
  '474': 474,
  '483': 483,
  '495': 495,
  '508': 508,
  '530': 530,
  '532': 532,
  '553': 553,
  '558': 558,
  '568': 568,
  '583': 583,
  '586': 586,
  '596': 596,
  '602': 602,
  '611': 611,
  '613': 613,
  '649': 649,
  '659': 659,
  '666': 666,
  '676': 676,
  '681': 681,
  '700': 700,
  '702': 702,
  '714': 714,
  '738': 738,
  '760': 760,
  '768': 768,
  '769': 769,
  '773': 773,
  '776': 776,
  '804': 804,
  '816': 816,
  '852': 852,
  '876': 876,
  '898': 898,
  '903': 903,
  '934': 934,
  '953': 953,
  '968': 968,
  '969': 969,
  '995': 995,
  '1049': 1049,
  '1186': 1186,
  '1245': 1245,
  '1249': 1249,
  '1250': 1250,
  '1316': 1316,
  '1319': 1319,
  '1340': 1340,
  '1393': 1393,
  '1426': 1426,
  '1432': 1432,
  '1516': 1516,
  '1525': 1525,
  '1531': 1531,
  '1547': 1547,
  '1579': 1579,
  '1620': 1620,
  '1687': 1687,
  '1701': 1701,
  '1925': 1925,
  '1928': 1928,
  '2034': 2034,
  '2067': 2067,
  '2150': 2150,
  '2286': 2286,
  '104 N': '104 N',
  OTHER_UNION: 'Other Union',
};

// eslint-disable-next-line camelcase
export const union_classifications = {
  '2': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '3': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '9': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '12': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '17': {
    N_A: 'N/A',
    L17_A_FOREMAN: 'A Foreman',
    L17_C_FOREMAN: 'C Foreman',
    L17_B_FOREMAN: 'B Foreman',
    L17_LABOR_FOREMAN: 'Labor Foreman',
    L17_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    L17_JOURNEYMAN_TECHNICIAN: 'Journeyman Technician',
    L17_LINEMAN_SPECIALIST: 'Lineman Specialist',
    L17_STATION_OPERATOR: 'Station Operator',
    L17_STATION_MAINTENANCE_TECHNICIAN: 'Station Maintenance Technician',
    L17_APPRENTICE_LINEMAN_1: 'Apprentice Lineman 1',
    L17_APPRENTICE_LINEMAN_2: 'Apprentice Lineman 2',
    L17_APPRENTICE_LINEMAN_3: 'Apprentice Lineman 3',
    L17_APPRENTICE_LINEMAN_4: 'Apprentice Lineman 4',
    L17_APPRENTICE_LINEMAN_5: 'Apprentice Lineman 5',
    L17_APPRENTICE_LINEMAN_6: 'Apprentice Lineman 6',
    L17_APPRENTICE_LINEMAN_7: 'Apprentice Lineman 7',
    L17_COMBINATION_EARTH_BORING: 'Combination Earth Boring',
    L17_TRACTOR_OPERATOR: 'Tractor Operator',
    L17_POLE_HAUL_DRIVER: 'Pole Haul Driver',
    L17_TRUCK_DRIVER: 'Truck Driver',
    L17_MATERIAL_HANDLER: 'Material Handler',
    L17_POLE_HAUL_HELPER: 'Pole Haul Helper',
    L17_LINE_CREW_GROUNDMAN: 'Line Crew Groundman',
    L17_GROUNDMAN: 'Groundman',
  },
  '37': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '42': {
    N_A: 'N/A',
    L42_GENERAL_FOREMAN: 'General Foreman',
    L42_FOREMAN: 'Foreman',
    L42_LEAD_LINEMAN: 'Lead Lineman',
    L42_CABLE_SPLICER: 'Cable Splicer',
    L42_DYNAMITE_MAN: 'Dynamite Man',
    L42_LINEMAN: 'Lineman',
    L42_APPRENTICE_1: 'Apprentice 1',
    L42_APPRENTICE_2: 'Apprentice 2',
    L42_APPRENTICE_3: 'Apprentice 3',
    L42_APPRENTICE_4: 'Apprentice 4',
    L42_APPRENTICE_5: 'Apprentice 5',
    L42_APPRENTICE_6: 'Apprentice 6',
    L42_APPRENTICE_7: 'Apprentice 7',
    L42_HEAVY_EQUIP_OPER: 'Heavy Equip Oper',
    L42_MAT_MAN_TT_DRIVER: 'Mat Man TT Driver',
    L42_EQUIP_OPER_F_MECH_A: 'Equip Oper F Mech A',
    L42_DR_GROUNDMAN: 'Dr Groundman',
    L42_FIELD_MECH_B: 'Field Mech B',
    L42_FIELD_MECH_C: 'Field Mech C',
    L42_GROUNDMAN_EXPERIENCED: 'Groundman Experienced',
    L42_FIRST_YEAR_GROUNDMAN: 'First Year Groundman',
    L42_FLAGMAN: 'Flagman',
  },
  '44': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '47': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '51': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '53': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '55': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '57': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '66': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '70': {
    N_A: 'N/A',
    L245_FOREMAN: 'Foreman',
    L245_SUB_FOREMAN: 'Sub Foreman',
    L245_FOREMAN_HOLE_DIGGING: 'Foreman Hole Digging',
    L245_LINEMAN_JOURNEYMAN_: 'Lineman Journeyman',
    L245_SUBSTATION_TECHNICIAN: 'Substation Technician',
    L245_TRANSMISSION_TECHNICIAN: 'Transmission Technician',
    L245_CABLE_SPLICER: 'Cable Splicer',
    L245_LINEMAN_SUBSTANCIAL_APPRENTICE_1: 'Lineman Substancial Apprentice 1',
    L245_LINEMAN_SUBSTANCIAL_APPRENTICE_2: 'Lineman Substancial Apprentice 2',
    L245_LINEMAN_SUBSTANCIAL_APPRENTICE_3: 'Lineman Substancial Apprentice 3',
    L245_LINEMAN_SUBSTANCIAL_APPRENTICE_4: 'Lineman Substancial Apprentice 4',
    L245_LINEMAN_SUBSTANCIAL_APPRENTICE_5: 'Lineman Substancial Apprentice 5',
    L245_LINEMAN_SUBSTANCIAL_APPRENTICE_6: 'Lineman Substancial Apprentice 6',
    L245_LINEMAN_SUBSTANCIAL_APPRENTICE_7: 'Lineman Substancial Apprentice 7',
    L245_TRANSMISSION_TECH_APPRENTICE_1: 'Transmission Tech Apprentice 1',
    L245_TRANSMISSION_TECH_APPRENTICE_2: 'Transmission Tech Apprentice 2',
    L245_TRANSMISSION_TECH_APPRENTICE_3: 'Transmission Tech Apprentice 3',
    L245_TRANSMISSION_TECH_APPRENTICE_4: 'Transmission Tech Apprentice 4',
    L245_EQUIPMENT_MECHANIC: 'Equipment Mechanic',
    L245_OPERATOR_C: 'Operator C',
    L245_OPERATOR_B: 'Operator B',
    L245_OPERATOR_A: 'Operator A',
    L245_LINE_TRUCK_W_AUGER: 'Line Truck W Auger',
    L245_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
  },
  '71': {
    N_A: 'N/A',
    L71_FOREMAN: 'Foreman',
    L71_SUB_FOREMAN: 'Sub Foreman',
    L71_FOREMAN_HOLE_DIGGER: 'Foreman Hole Digger',
    L71_LINEMAN_JOURNEYMAN: 'Lineman Journeyman',
    L71_SUBSTATION_TECHNICIAN: 'Substation Technician',
    L71_CABLE_SPLICER: 'Cable Splicer',
    L71_LINEMAN_SUBSTANCIAL_APPRENTICE_1: 'Lineman Substancial Apprentice 1',
    L71_LINEMAN_SUBSTANCIAL_APPRENTICE_2: 'Lineman Substancial Apprentice 2',
    L71_LINEMAN_SUBSTANCIAL_APPRENTICE_3: 'Lineman Substancial Apprentice 3',
    L71_LINEMAN_SUBSTANCIAL_APPRENTICE_4: 'Lineman Substancial Apprentice 4',
    L71_LINEMAN_SUBSTANCIAL_APPRENTICE_5: 'Lineman Substancial Apprentice 5',
    L71_LINEMAN_SUBSTANCIAL_APPRENTICE_6: 'Lineman Substancial Apprentice 6',
    L71_LINEMAN_SUBSTANCIAL_APPRENTICE_7: 'Lineman Substancial Apprentice 7',
    L71_EQUIPMENT_MECHANIC_C: 'Equipment Mechanic C',
    L71_EQUIPMENT_MECHANIC_B: 'Equipment Mechanic B',
    L71_EQUIPMENT_MECHANIC_A: 'Equipment Mechanic A',
    L71_OPERATOR_C: 'Operator C',
    L71_OPERATOR_B: 'Operator B',
    L71_OPERATOR_A: 'Operator A',
    L71_LINE_TRUCK_W_AUGER: 'Line Truck W Auger',
    L71_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
  },
  '77': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '80': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '84': {
    N_A: 'N/A',
    L84_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    L84_LEAD_LINEMAN: 'Lead Lineman',
    L84_FOREMAN: 'Foreman',
    L84_GENERAL_FOREMAN: 'General Foreman',
    L84_HEAVY_EQP_OPERATOR: 'Heavy Eqp Operator',
    L84_EQUIPMENT_OPERATOR: 'Equipment Operator',
    L84_TRUCK_OPERATOR: 'Truck Operator',
    L84_GROUNDMAN_OVER_6_MNTH: 'Groundman Over 6 Mnth',
    L84_APPRENTICE_1: 'Apprentice 1',
    L84_APPRENTICE_2: 'Apprentice 2',
    L84_APPRENTICE_3: 'Apprentice 3',
    L84_APPRENTICE_4: 'Apprentice 4',
    L84_APPRENTICE_5: 'Apprentice 5',
    L84_APPRENTICE_6: 'Apprentice 6',
    L84_APPRENTICE_7: 'Apprentice 7',
  },
  '89': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '102': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '104': {
    N_A: 'N/A',
    L104_GENERAL_FOREMAN: 'General Foreman',
    L104_FOREMAN: 'Foreman',
    L104_HEAD_LINEMAN: 'Head Lineman',
    L104_LINEMAN_SPLICER: 'Lineman Splicer',
    L104_APPRENTICE_1: 'Apprentice 1',
    L104_APPRENTICE_2: 'Apprentice 2',
    L104_APPRENTICE_3: 'Apprentice 3',
    L104_APPRENTICE_4: 'Apprentice 4',
    L104_APPRENTICE_5: 'Apprentice 5',
    L104_APPRENTICE_6: 'Apprentice 6',
    L104_APPRENTICE_7: 'Apprentice 7',
    L104_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    L104_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    L104_CABLEMAN: 'Cableman',
    L104_DRIVER_GROUNDMAN_CDL: 'Driver Groundman CDL',
    L104_INEXPERIENCED_DRIVER_GROUNDMAN: 'Inexperienced Driver Groundman',
    L104_CABLE_TECHNICIAN: 'Cable Technician',
    L104_GROUNDMAN: 'Groundman',
    L104_INEXPERIENCED_GROUNDMAN: 'Inexperienced Groundman',
  },
  '105': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '111': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '113': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '115': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '120': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '125': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '126': {
    N_A: 'N/A',
    L126_GENERAL_FOREMAN: 'General Foreman',
    L126_FOREMAN: 'Foreman',
    L126_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    L126_DUCT_FOREMAN: 'Duct Foreman',
    L126_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    L126_JOURNEYMAN_TECHNICAL: 'Journeyman Technical',
    L126_DYNAMITE_MAN: 'Dynamite Man',
    L126_APPRENTICE_1: 'Apprentice 1',
    L126_APPRENTICE_2: 'Apprentice 2',
    L126_APPRENTICE_3: 'Apprentice 3',
    L126_APPRENTICE_4: 'Apprentice 4',
    L126_APPRENTICE_5: 'Apprentice 5',
    L126_APPRENTICE_6: 'Apprentice 6',
    L126_APPRENTICE_7: 'Apprentice 7',
    L126_A_OPERATOR: 'A Operator',
    L126_B_OPERATOR: 'B Operator',
    L126_EQUIPMENT_OPERATOR: 'Equipment Operator',
    L126_LINE_EQUIPMENT_MECHANIC: 'Line Equipment Mechanic',
    L126_DIRECTION_DRILLER: 'Direction Driller',
    L126_LOCATOR: 'Locator',
    L126_SERVICEMAN: 'Serviceman',
    L126_WINCH_TRUCK_OPERATOR: 'Winch Truck Operator',
    L126_LINE_TRUCK_OPERATOR: 'Line Truck Operator',
    L126_GROUNDHAND: 'Groundhand',
    L126_STREET_LIGHT_REPAIRMAN: 'Street Light Repairman',
    L126_METER_PERSON: 'Meter Person',
    L126_FLAG_PERSON: 'Flag Person',
  },
  '141': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '145': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '160': {
    N_A: 'N/A',
    L160_GENERAL_FOREMAN: 'General Foreman',
    L160_FOREMAN: 'Foreman',
    L160_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    L160_APPRENTICE_1: 'Apprentice 1',
    L160_APPRENTICE_2: 'Apprentice 2',
    L160_APPRENTICE_3: 'Apprentice 3',
    L160_APPRENTICE_4: 'Apprentice 4',
    L160_APPRENTICE_5: 'Apprentice 5',
    L160_APPRENTICE_6: 'Apprentice 6',
    L160_APPRENTICE_7: 'Apprentice 7',
    L160_JOURNEYMAN_TECHNICIAN: 'Journeyman Technician',
    L160_CABLE_SPLICER: 'Cable Splicer',
    L160_DYNAMITER: 'Dynamiter',
    L160_SPECIAL_EQUIPMENT_OPERATOR: 'Special Equipment Operator',
    L160_EQUIPMENT_OPERATOR: 'Equipment Operator',
    L160_TRAINEE_OPERATOR_1: 'Trainee Operator 1',
    L160_TRAINEE_OPERATOR_2: 'Trainee Operator 2',
    L160_SENIOR_GROUNDMAN_TRUCK_DRIVER: 'Senior Groundman Truck Driver',
    L160_GROUNDMAN: 'Groundman',
    L160_GROUNDMAN_POLE_TREATING_SPECIALIST: 'Groundman Pole Treating Specialist',
    L160_GROUNDMAN_POLE_TREATING_INSPECTOR: 'Groundman Pole Treating Inspector',
    L160_GROUNDMAN_POLE_TREATING_TRUCK_DRIVER: 'Groundman Pole Treating Truck Driver',
    L160_STREET_LIGHT_TECHNICIAN: 'Street Light Technician',
  },
  '164': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '175': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '177': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '193': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '196': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '206': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '220': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '222': {
    N_A: 'N/A',
    L222_GENERAL_FOREMAN: 'General Foreman',
    L222_FOREMAN: 'Foreman',
    L222_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    L222_HEAVY_EQUIP_OP: 'Heavy Equip Op',
    L222_OPERATOR: 'Operator',
    L222_CABLE_SPLICER: 'Cable Splicer',
    L222_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    L222_APPRENTICE_LINEMAN_1: 'Apprentice Lineman 1',
    L222_APPRENTICE_LINEMAN_2: 'Apprentice Lineman 2',
    L222_APPRENTICE_LINEMAN_3: 'Apprentice Lineman 3',
    L222_APPRENTICE_LINEMAN_4: 'Apprentice Lineman 4',
    L222_APPRENTICE_LINEMAN_5: 'Apprentice Lineman 5',
    L222_APPRENTICE_LINEMAN_6: 'Apprentice Lineman 6',
    L222_APPRENTICE_LINEMAN_7: 'Apprentice Lineman 7',
  },
  '238': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '245': {
    N_A: 'N/A',
    L245_FOREMAN: 'Foreman',
    L245_SUB_FOREMAN: 'Sub Foreman',
    L245_FOREMAN_HOLE_DIGGER: 'Foreman Hole Digger',
    L245_LINEMAN_JOURNEYMAN: 'Lineman Journeyman',
    L245_SUBSTATION_TECHNICIAN: 'Substation Technician',
    L245_CABLE_SPLICER: 'Cable Splicer',
    L245_LINEMAN_SUBSTANCIAL_APPRENTICE_1: 'Lineman Substancial Apprentice 1',
    L245_LINEMAN_SUBSTANCIAL_APPRENTICE_2: 'Lineman Substancial Apprentice 2',
    L245_LINEMAN_SUBSTANCIAL_APPRENTICE_3: 'Lineman Substancial Apprentice 3',
    L245_LINEMAN_SUBSTANCIAL_APPRENTICE_4: 'Lineman Substancial Apprentice 4',
    L245_LINEMAN_SUBSTANCIAL_APPRENTICE_5: 'Lineman Substancial Apprentice 5',
    L245_LINEMAN_SUBSTANCIAL_APPRENTICE_6: 'Lineman Substancial Apprentice 6',
    L245_LINEMAN_SUBSTANCIAL_APPRENTICE_7: 'Lineman Substancial Apprentice 7',
    L245_EQUIPMENT_MECHANIC_C: 'Equipment Mechanic C',
    L245_EQUIPMENT_MECHANIC_B: 'Equipment Mechanic B',
    L245_EQUIPMENT_MECHANIC_A: 'Equipment Mechanic A',
    L245_OPERATOR_C: 'Operator C',
    L245_OPERATOR_B: 'Operator B',
    L245_OPERATOR_A: 'Operator A',
    L245_LINE_TRUCK_W_AUGER: 'Line Truck W Auger',
    L245_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
  },
  '254': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '258': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '269': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '270': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '278': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '291': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '295': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '301': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '303': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '304': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '307': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '309': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '317': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '322': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '342': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '351': {
    N_A: 'N/A',
    L351_GENERAL_FOREMAN: 'General Foreman',
    L351_FOREMAN: 'Foreman',
    L351_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    L351_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    L351_CABLE_SPLICER: 'Cable Splicer',
    L351_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    L351_JOURNEYMAN_WELDER: 'Journeyman Welder',
    L351_JOURNEYMAN_PAINTER: 'Journeyman Painter',
    L351_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    L351_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    L351_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    L351_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    L351_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    L351_FLAGMAN: 'Flagman',
    L351_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    L351_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    L351_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    L351_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    L351_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    L351_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    L351_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
  },
  '353': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '369': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '379': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '396': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '400': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '402': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '424': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '426': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '429': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '443': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '449': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '456': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '474': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '483': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '495': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '508': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '530': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '532': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '553': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '558': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '568': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '583': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '586': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '596': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '602': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '611': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '613': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '649': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '659': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '666': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '676': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '681': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '700': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '702': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '714': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '738': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '760': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '768': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '769': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '773': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '776': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '804': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '816': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '852': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '876': {
    N_A: 'N/A',
    L876_FOREMAN_IN_CHANGE_OF_LINE_OR_SUBSTATION: 'Foreman In Change Of Line Or Substation',
    L876_FOREMAN_IN_CHANGE_OF_POLE_SETTING: 'Foreman In Change Of Pole Setting',
    L876_SUB_FOREMAN: 'Sub Foreman',
    L876_CABLE_SPLICER: 'Cable Splicer',
    L876_LINEMAN_SERVICE_WORKER: 'Lineman Service Worker',
    L876_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    L876_JOURNEYMAN_SUBSTATION_TECHNICIAN: 'Journeyman Substation Technician',
    L876_APPRENTICE_LINEMAN_1: 'Apprentice Lineman 1',
    L876_APPRENTICE_LINEMAN_2: 'Apprentice Lineman 2',
    L876_APPRENTICE_LINEMAN_3: 'Apprentice Lineman 3',
    L876_APPRENTICE_LINEMAN_4: 'Apprentice Lineman 4',
    L876_APPRENTICE_LINEMAN_5: 'Apprentice Lineman 5',
    L876_APPRENTICE_LINEMAN_6: 'Apprentice Lineman 6',
    L876_APPRENTICE_LINEMAN_7: 'Apprentice Lineman 7',
    L876_OPERATOR_GROUNDMAN: 'Operator Groundman',
    L876_LIGHT_EQUIPMENT_OPERATOR_GROUNDMAN_TRUCK_DRIVER_GROUNDMAN: 'Light Equipment Operator Groundman Truck Driver Groundman',
    L876_GROUNDMAN_TRUCK_DRIVER_GROUNDMAN: 'Groundman Truck Driver Groundman',
    L876_UNDERGROUND_DISTR_SUB_TECH_1ST: 'Underground Distr Sub Tech 1st',
    L876_UNDERGROUND_DISTR_SUB_TECH: 'Underground Distr Sub Tech',
  },
  '898': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '903': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '934': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '953': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '968': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '969': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '995': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W Cdl',
  },
  '1049': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1186': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1245': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1249': {
    N_A: 'N/A',
    L1249_GENERAL_FOREMAN: 'General Foreman',
    L1249_FOREMAN: 'Foreman',
    L1249_WORKING_FOREMAN: 'Working Foreman',
    L1249_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    L1249_APPRENTICE_1: 'Apprentice 1',
    L1249_APPRENTICE_2: 'Apprentice 2',
    L1249_APPRENTICE_3: 'Apprentice 3',
    L1249_APPRENTICE_4: 'Apprentice 4',
    L1249_APPRENTICE_5: 'Apprentice 5',
    L1249_APPRENTICE_6: 'Apprentice 6',
    L1249_APPRENTICE_7: 'Apprentice 7',
    L1249_GR_DIGGING_MACHINE_OPER: 'Digging Machine Operator',
    L1249_CHIEF_MECHANIC: 'Chief Mechanic',
    L1249_MECHANIC_FIRST_CLASS: 'Mechanic First Class',
    L1249_MECHANIC_HELPER: 'Mechanic Helper',
    L1249_GROUNDMAN_TRUCK_DRIVER_TT_EO_W_CDL_A: 'Groundman Truck Driver TT/EO W CDL A',
    L1249_GROUNDMAN_TRUCK_DRIVER_EO_W_CDL_B: 'Groundman Truck Driver EO W CDL B',
    L1249_GROUNDMAN: 'Groundman',
    L1249_FLAGMAN: 'Flagman',
  },
  '1250': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1316': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1319': {
    N_A: 'N/A',
    L1319_GENERAL_FOREMAN: 'General Foreman',
    L1319_FOREMAN: 'Foreman',
    L1319_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    L1319_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    L1319_APPRENTICE_1: 'Apprentice 1',
    L1319_APPRENTICE_2: 'Apprentice 2',
    L1319_APPRENTICE_3: 'Apprentice 3',
    L1319_APPRENTICE_4: 'Apprentice 4',
    L1319_APPRENTICE_5: 'Apprentice 5',
    L1319_APPRENTICE_6: 'Apprentice 6',
    L1319_APPRENTICE_7: 'Apprentice 7',
    L1319_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    L1319_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    L1319_EQUIPMENT_OPERATOR: 'Equipment Operator',
    L1319_VAC_TR_DIR_BORING: 'Vac Truck/Directional Boring',
    L1319_DYNAMIT_MAN: 'Dynamite Man',
    L1319_GR_TRUCK_DRIVER_W: 'Groundman Truck Driver W',
    L1319_GROUNDMAN_TRUCK_DR: 'Groundman Truck Driver',
    L1319_GROUNDMAN: 'Groundman',
    L1319_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    L1319_FLAGMAN: 'Flagman',
    L1319_LINE_EQUIP_MECH_WELDER: 'Line Equipment Mechanic Welder',
    L1319_EQ_SERV_MECH_HELPER: 'Equipment Service Mechanic Helper',
  },
  '1340': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1393': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1426': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1432': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1516': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1525': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1531': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1547': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1579': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1620': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1687': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1701': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1925': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '1928': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '2034': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '2067': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '2150': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '2286': {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman W CDL',
  },
  '104 N': {
    N_A: 'N/A',
    L104N_GENERAL_FOREMAN: 'General Foreman',
    L104N_FOREMAN: 'Foreman',
    L104N_HEAD_LINEMAN: 'Head Lineman',
    L104N_JOURNEYMAN_LINEMAN_SPLICER: 'Journeyman Lineman Splicer',
    L104N_APPRENTICE_1: 'Apprentice 1',
    L104N_APPRENTICE_2: 'Apprentice 2',
    L104N_APPRENTICE_3: 'Apprentice 3',
    L104N_APPRENTICE_4: 'Apprentice 4',
    L104N_APPRENTICE_5: 'Apprentice 5',
    L104N_APPRENTICE_6: 'Apprentice 6',
    L104N_APPRENTICE_7: 'Apprentice 7',
    L104N_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    L104N_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    L104N_CABLEMAN: 'Cableman',
    L104N_DRIVER_GROUNDMAN_CDL: 'Driver Groundman CDL',
    L104N_INEXPERIENCED_DRIVER_GROUNDMAN: 'Inexperienced Driver Groundman',
    L104N_CABLE_TECHNICIAN: 'Cable Technician',
    L104N_GROUNDMAN: 'Groundman',
    L104N_INEXPERIENCED_GROUNDMAN: 'Inexperienced Groundman',
  },
  OTHER_UNION: {
    N_A: 'N/A',
    LOTHER_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LOTHER_APPRENTICE_1: 'Apprentice 1',
    LOTHER_APPRENTICE_2: 'Apprentice 2',
    LOTHER_APPRENTICE_3: 'Apprentice 3',
    LOTHER_APPRENTICE_4: 'Apprentice 4',
    LOTHER_APPRENTICE_5: 'Apprentice 5',
    LOTHER_APPRENTICE_6: 'Apprentice 6',
    LOTHER_APPRENTICE_7: 'Apprentice 7',
    LOTHER_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LOTHER_GROUNDMAN: 'Groundman',
  },
  GENERIC: {
    N_A: 'N/A',
    LGEN_GENERAL_FOREMAN: 'General Foreman',
    LGEN_FOREMAN: 'Foreman',
    LGEN_SMALL_JOB_FOREMAN: 'Small Job Foreman',
    LGEN_WORKING_FOREMAN: 'Working Foreman',
    LGEN_HEAVY_EQUIPMENT_OPERATOR: 'Heavy Equipment Operator',
    LGEN_CABLE_SPLICER: 'Cable Splicer',
    LGEN_JOURNEYMAN_LINEMAN: 'Journeyman Lineman',
    LGEN_JOURNEYMAN_WIREMAN: 'Journeyman Wireman',
    LGEN_LIGHT_EQUIPMENT_OPERATOR: 'Light Equipment Operator',
    LGEN_GROUNDMAN_TRUCK_DRIVER: 'Groundman Truck Driver',
    LGEN_GROUNDMAN_3RD_YEAR: 'Groundman 3rd Year',
    LGEN_GROUNDMAN_2ND_YEAR: 'Groundman 2nd Year',
    LGEN_GROUNDMAN_1ST_YEAR: 'Groundman 1st Year',
    LGEN_FLAGMAN: 'Flagman',
    LGEN_APPRENTICE_JOURNEYMAN_1: 'Apprentice Journeyman 1',
    LGEN_APPRENTICE_JOURNEYMAN_2: 'Apprentice Journeyman 2',
    LGEN_APPRENTICE_JOURNEYMAN_3: 'Apprentice Journeyman 3',
    LGEN_APPRENTICE_JOURNEYMAN_4: 'Apprentice Journeyman 4',
    LGEN_APPRENTICE_JOURNEYMAN_5: 'Apprentice Journeyman 5',
    LGEN_APPRENTICE_JOURNEYMAN_6: 'Apprentice Journeyman 6',
    LGEN_APPRENTICE_JOURNEYMAN_7: 'Apprentice Journeyman 7',
    LGEN_LEAD_LINEMAN: 'Lead Lineman',
    LGEN_EQUIPMENT_OPERATOR: 'Equipment Operator',
    LGEN_EQUIPMENT_OPERATOR_A: 'Equipment Operator A',
    LGEN_EQUIPMENT_OPERATOR_B: 'Equipment Operator B',
    LGEN_GROUNDMAN_W_CDL: 'Groundman w/CDL',
  },
};
